import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'

import {slideshow} from './js/sliders'
import {Cart} from './js/cart'
import Echivalente from "./js/echivalente";
import {loadMore} from "./js/load-more";
import {filters} from "./js/filters";
import {agree} from "./js/agree";
import {search} from "./js/search";
import {zones} from "./js/zones";
import {cities} from "./js/cities";
import {carFilter} from "./js/cars/carFilter";
import {nextPage} from "./js/paginate";
import {checkout} from "./js/checkout";

window.Cart = Cart
window.Echivalente = Echivalente
window.loadMore = loadMore
window.filters = filters
window.agree = agree
window.zones = zones
window.cities = cities
window.checkout = checkout
window.search = search
window.carFilter = carFilter
window.Alpine = Alpine
window.nextPage = nextPage
Alpine.plugin(persist)
Alpine.start()

window.onload = (() => {
    slideshow()
})

